import React from "react";

export default function Web_Responsive() {
  return (
    <div>
      <h1>What is Responsive</h1>
      <p>
        Route: <code>/web/responsive</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
